import axios from 'axios';
import { urlApiAsesoria } from '../Config/baseUrl';
import { IGetMiniCurso } from '../Interfaces/IMiniCurso';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const getMiniCurso = (data: IGetMiniCurso) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/minicurso', data, config);
};
